export class LoginforignerDto {
  email?: string;
  password?: string; 
}
